import { ROUTES } from './routes'
import { CATALOG_SETTINGS_LABEL } from './catalog'

const INTEGRATIONS_ENABLED =
  process.env.NEXT_PUBLIC_GCLICK_ENABLED === 'true' ||
  process.env.NEXT_PUBLIC_OMIE_ENABLED === 'true'

export const csatMessageKey = 'csat-message'
export const departmentRoutingKey = 'department-routing'
export const conversationFinishKey = 'conversation-finish'
export const waitingConversationMonitorKey = 'waiting-conversation-monitor'
export const attendanceSignatureKey = 'attendance-signature'

export type SettingItem = {
  id: string
  name: string
  path?: string
  key?: string
  action?: string
}

export function getSettingItemId(setting: SettingItem) {
  return setting.id
}

export function getUniqueSettings(settings: SettingItem[]) {
  const ids = new Set<string>()

  return settings.filter((setting) => {
    const id = getSettingItemId(setting)

    if (ids.has(id)) {
      return false
    }

    ids.add(id)

    return true
  })
}

export const companySettings: SettingItem[] = [
  { id: 'products-services', name: CATALOG_SETTINGS_LABEL, path: ROUTES.PRODUCTS_SERVICES.PATH },
  {
    id: 'audio-transcription',
    name: 'Transcrição de áudios',
    path: ROUTES.AUDIO_TRANSCRIPTION_USAGE.PATH,
  },
  { id: 'demands', name: 'Demandas', path: ROUTES.LIST_DEMANDS.PATH },
  {
    id: 'departments',
    name: 'Departamentos',
    path: ROUTES.LIST_DEPARTMENTS.PATH,
  },
  {
    id: 'cac-expenses',
    name: 'Despesas (CAC)',
    path: ROUTES.LIST_CAC_EXPENSES.PATH,
  },
  {
    id: 'anniversary-messages',
    name: 'Mensagens de aniversário',
    path: ROUTES.ANNIVERSARY_MESSAGES.PATH,
  },
  {
    id: 'commemorative-messages',
    name: 'Mensagens comemorativas',
    path: ROUTES.COMMEMORATIVE_MESSAGES.PATH,
  },
  {
    id: 'absence-messages',
    name: 'Mensagens de ausência',
    path: ROUTES.ABSENCE_MESSAGES.PATH,
  },
  {
    id: 'department-routing',
    name: 'Bot de atendimento inicial (direcionamento por departamento)',
    key: departmentRoutingKey,
  },
  {
    id: 'conversation-finish',
    name: 'Finalização de atendimento',
    key: conversationFinishKey,
  },
  {
    id: 'waiting-conversation-monitor',
    name: 'Monitor de atendimentos aguardando',
    path: ROUTES.WAITING_CONVERSATION_MONITOR.PATH,
  },
  {
    id: attendanceSignatureKey,
    name: 'Assinatura no atendimento',
    action: 'setIsAttendanceSignatureDialogOpen',
  },
  {
    id: 'quick-messages',
    name: 'Mensagens rápidas',
    path: ROUTES.QUICK_MESSAGES.PATH,
  },
  {
    id: 'whatsapp-templates',
    name: 'Templates WhatsApp',
    path: ROUTES.WHATSAPP_TEMPLATES.PATH,
  },
  {
    id: 'whatsapp-routing',
    name: 'Uso da API oficial',
    path: ROUTES.WHATSAPP_ROUTING.PATH,
  },
  { id: 'csat-message', name: 'Mensagem CSAT', key: csatMessageKey },
  { id: 'niches', name: 'Segmentos', path: ROUTES.LIST_NICHES.PATH },
  {
    id: 'whatsapp-number',
    name: 'Número do WhatsApp',
    action: 'setIsUpdateWhatsAppNumberDialogOpen',
  },
  {
    id: 'client-origins',
    name: 'Origens dos clientes',
    path: ROUTES.LIST_CLIENT_ORIGINS.PATH,
  },
  { id: 'tags', name: 'Tags', path: ROUTES.LIST_TAGS.PATH },
  ...(INTEGRATIONS_ENABLED
    ? [
        {
          id: 'integrations',
          name: 'Integrações',
          path: ROUTES.INTEGRATIONS.PATH,
        },
      ]
    : []),
]

export const demandSettings: SettingItem[] = [
  { id: 'demands', name: 'Demandas', path: ROUTES.LIST_DEMANDS.PATH },
]

export const adminSettings: SettingItem[] = [
  {
    id: 'whatsapp-costs',
    name: 'Tarifas da API oficial',
    path: ROUTES.WHATSAPP_COSTS.PATH,
  },
  { id: 'demands', name: 'Demandas', path: ROUTES.LIST_DEMANDS.PATH },
  {
    id: 'departments',
    name: 'Departamentos',
    path: ROUTES.LIST_DEPARTMENTS.PATH,
  },
  {
    id: 'journey-templates',
    name: 'Jornadas Padrão',
    path: ROUTES.LIST_JOURNEY_TEMPLATES.PATH,
  },
  { id: 'plans', name: 'Planos', path: ROUTES.LIST_PLANS.PATH },
  {
    id: 'help-center',
    name: 'Central de Ajuda',
    path: ROUTES.LIST_HELP_RESOURCES.PATH,
  },
  { id: 'notifications', name: 'Avisos', path: ROUTES.LIST_NOTIFICATIONS.PATH },
  {
    id: 'system-update',
    name: 'Atualização do sistema',
    path: ROUTES.SYSTEM_UPDATE_NOTICE.PATH,
  },
]
